export const ShowFlodNamesMinxins = {
        props: {
                // 显示相同的parentId下的指定的floadName的照片
                showFlodNames: {
                        type: Array,
                        default: () => {
                                return []
                        }
                }
        },
        data() {
                return {
                        showFlodNamesFileList: [],
                        valuableSubcomponents: []
                };
        },
        methods: {
                // 拿到需要合并显示的组件的图片集 以及 子组件实例
                dataFusion() {
                        this.showFlodNamesFileList = []
                        this.valuableSubcomponents = []
                        // 把需要合并操作的子组件拿出来
                        let childrenArr = this.$parent.$children
                        childrenArr.forEach(item => {
                                // 这里可以拿到所有的关于 showFlodNames 的指定数据大于0 的图片
                                if (item.showFlodNames && item.showFlodNames.length > 0) {
                                        this.showFlodNamesFileList.push(...item.fileList)
                                        this.valuableSubcomponents.push(item)
                                }
                        })
                        console.log("showFlodNamesFileList", this.showFlodNamesFileList,this.pointIndex)
                        if (typeof this.showFlodNamesFileList.filter(u =>u.flodName === this.pointIndex)[this.checkedPic]!== 'undefined') {
                                this.bigPic = this.showFlodNamesFileList.filter(u =>u.flodName === this.pointIndex)[this.checkedPic].url
                        }
                },
                addFlodName() {
                        let pics = this.showFlodNamesFileList.filter(x => x.flodName === this.pointIndex)
                        if (this.checkedPic + 1 < pics.length) {
                                let v = this.checkedPic + 1
                                this.checkedPicPointFlodName(pics[v], v)
                        }
                },
                reduceFlodName() {
                        let pics = this.showFlodNamesFileList.filter(x => x.flodName === this.pointIndex)
                        if (this.checkedPic > 0) {
                                let v = this.checkedPic - 1
                                this.checkedPicPointFlodName(pics[v], v)
                        }
                },
                checkedPicPointFlodName(pic, index) {
                        this.checkedPic = index
                        let container = document.getElementById("photoWall")
                        var elementsByClassNameElement = document.getElementsByClassName("picKuai")[index];
                        // 水平滚动
                        let x = elementsByClassNameElement.offsetLeft - container.clientWidth + container.clientWidth / 2 + elementsByClassNameElement.clientWidth / 2;
                        container.scrollTo({
                                left: x,
                                behavior: "smooth",
                        });
                        this.bigPic = pic.url
                },
                deletePicFlodName(index) {
                        if (this.showFlodNamesFileList.filter(u => u.flodName === this.pointIndex)[index].id) {
                                this.deletePicData(this.showFlodNamesFileList.filter(u => u.flodName === this.pointIndex)[index].id).then((res) => {
                                        if (res) {
                                                this.valuableSubcomponents.forEach(item => {
                                                        // 寻找跟id对应的那个组件
                                                        var _findIndex = item.fileList.findIndex((n) => n.id === this.showFlodNamesFileList.filter(u => u.flodName === this.pointIndex)[index].id);
                                                        if (_findIndex > -1) {
                                                                item.fileList = item.fileList.filter((n) => n.id !== this.showFlodNamesFileList.filter(u => u.flodName === this.pointIndex)[index].id);
                                                        }
                                                })
                                                // 寻找Index
                                                let _findIndex = this.showFlodNamesFileList.findIndex(u => u.id === this.showFlodNamesFileList.filter(u => u.flodName === this.pointIndex)[index].id)
                                                if (_findIndex > -1) {
                                                        this.showFlodNamesFileList.splice(_findIndex, 1)
                                                }
                                                this.reduceFlodName()
                                                if (this.showFlodNamesFileList.length === 0) {
                                                        this.checkedPic = 0
                                                        this.isExistence = false
                                                        this.bigPic = ''
                                                        this.picShow = false
                                                } else {
                                                        this.bigPic = this.showFlodNamesFileList.filter(u => u.flodName === this.pointIndex)[this.checkedPic].url
                                                }
                                        }
                                });
                        } else {
                                this.valuableSubcomponents.forEach(item => {
                                        item.fileList = item.fileList.filter((n) => n.uid !== this.showFlodNamesFileList.filter(u => u.flodName === this.pointIndex)[index].uid);
                                })
                                this.showFlodNamesFileList = this.showFlodNamesFileList.filter((n) => n.uid !== this.showFlodNamesFileList[index].uid);
                                this.reduceFlodName()
                                if (this.showFlodNamesFileList.length === 0) {
                                        this.checkedPic = 0
                                        this.isExistence = false
                                        this.bigPic = ''
                                        this.picShow = false
                                } else {
                                        this.bigPic = this.showFlodNamesFileList.filter(u => u.flodName === this.pointIndex)[this.checkedPic].url
                                }
                        }
                        this.dataFusion()
                },
                singleUploadFlodName(uploadPic) {
                        this.icon = "el-icon-loading"
                        this.iconText = "上传中..."
                        this.manualUpload([uploadPic], this.parentId).then(res => {
                                if (res) {
                                        this.icon = "el-icon-check"
                                        this.iconText = "上传成功"
                                        setTimeout(() => {
                                                this.icon = 'el-icon-upload2'
                                                this.iconText = '点击上传'
                                                if (document.getElementsByClassName("noways")[0]) {
                                                        document.getElementsByClassName("noways")[0].style.display = 'none'
                                                }
                                        }, 1000)
                                        this.valuableSubcomponents.forEach(item => {
                                                let _findAssembly = item.fileList.find(x => x.url === uploadPic.url);
                                                if (_findAssembly) {
                                                        // 寻找索引
                                                        var findIndex = item.fileList.findIndex(x => x.url === uploadPic.url);
                                                        item.fileList = item.fileList.filter(x => x.url !== uploadPic.url);
                                                        if (findIndex > -1) {
                                                                if (item.fileList.length === 0) {
                                                                        item.fileList.push(res)
                                                                } else {
                                                                        item.fileList.splice(findIndex, 0, res)
                                                                }
                                                        }
                                                        item.changeFileList(item.fileList)
                                                }
                                        })
                                        if (this.showFlodNamesFileList.filter(u => u.flodName === this.pointIndex).length === 0) {
                                                this.showFlodNamesFileList.push(res)
                                        } else {
                                                // 先把对应url的数据删掉
                                                let _findIndex = this.showFlodNamesFileList.findIndex(x => x.url === uploadPic.url)
                                                if (_findIndex > -1) {
                                                        this.showFlodNamesFileList.splice(_findIndex, 1)
                                                }
                                                this.showFlodNamesFileList.splice(this.checkedPic, 0, res)
                                        }
                                        this.bigPic = this.showFlodNamesFileList.filter(u => u.flodName === this.pointIndex)[this.checkedPic].url
                                }
                        })
                        console.log('single', uploadPic)
                }
        },
        mounted() {
                this.dataFusion();
                this.pointActive(this.pointIndex)
        }
}